import useAxios from '../hooks/useAxios'
import { useApi } from '../hooks'
import { PowerSupply, PowerSupplyInput, PowerSupplyUploadInput } from '../types'

const api = useApi('v2')

export async function getPowerSupplies(): Promise<PowerSupply[]> {
  const response = await api.get('/powersupplies')

  return response.data
}

export async function getPowerSupply(id: number): Promise<PowerSupply> {
  const response = await api.get(`/powersupplies/${id}`)

  return response.data
}

export async function updatePowerSupply(id: number, input: PowerSupplyInput): Promise<PowerSupply> {
  const response = await api.put(`/powersupplies/${id}`, input)

  return response.data
}

/**
 * @deprecated
 */
export async function getPowerSuppliesByProjectId(projectId: number): Promise<PowerSupply[]> {
  const axios = useAxios()

  const response = await axios.get(`/projects/${projectId}/powersupplies`)

  return response.data
}

/**
 * @deprecated
 */
export async function createPowerSupply(input: PowerSupplyInput): Promise<PowerSupply> {
  const axios = useAxios()

  const response = await axios.post('/powersupplies', input)

  return response.data
}

/**
 * @deprecated
 */
export async function deletePowerSupply(id: number): Promise<void> {
  const axios = useAxios()

  await axios.delete(`/powersupplies/${id}`)
}

export async function createPowerSupplyDocument(
  id: number,
  input: PowerSupplyUploadInput
): Promise<PowerSupply> {
  // Backed only accepts multipart/form-data for this endpoint
  const formData = new FormData()
  formData.append('file', input.file)

  if (input.expiresAt !== undefined) {
    formData.append('expiresAt', input.expiresAt.toISOString())
  }

  if (input.name !== undefined) {
    formData.append('name', input.name)
  }

  formData.append('createdAt', input.createdAt.toISOString())

  const response = await api.post(`/powersupplies/${id}/upload`, formData)

  return response.data
}

export default {
  getPowerSupplies,
  getPowerSupply,
  createPowerSupply,
  updatePowerSupply,
  deletePowerSupply
}
